<template>
	<div class="introduce">
		<Header></Header>
		<div class="viewBox">
			<div class="viewBoxContent">
				<div class="titleImg">
					<a
						href="#/column?id=247&name=五周年专题&uid=A623&showType=2"
						target="_blank"
					>
						<img src="../../assets/fiveth/title.png" alt="" />
					</a>
				</div>
				<!-- 时间线 -->
				<div class="year-timeline">
					<button
						v-for="(year, i) in years"
						:key="i"
						class="timeline-item"
						:class="{ active: year === currentYear }"
						@click="onYearChange(year)"
						type="button"
					>
						<span class="txt">{{ year }}</span>
					</button>
				</div>
				<div class="policy">
					<div class="policyBox1">
						<div class="policyTitle">
							<div
								class="asticle_l_title_item littleTitle flexRow"
								style="margin-bottom: 20px;"
							>
								<img
									src="../../assets/homeContent/title_icon.jpg"
									alt=""
								/>
								<a
									href="#/column?id=247&name=五周年专题&uid=A62301&showType=2"
									target="_blank"
									class="spanA"
									>习近平生态文明思想</a
								>
								<i></i>
								<a
									class="article_l_more"
									href="#/column?id=247&name=五周年专题&uid=A62301&showType=2"
									target="_blank"
									>更多<img
										src="../../assets/homeContent/more.png"
										alt=""
								/></a>
							</div>
							<div class="policyContent">
								<div>
									<img
										src="../../assets/fiveth/detailsImg.png"
										alt=""
									/>
								</div>
								<div class="policyDetailsBox">
									<div
										class="policyDetails"
										v-for="(item, index) in policy1"
										:key="index"
										v-if="policy1 && policy1.length"
									>
										<div class="detailsDate">
											{{ getMonth(item.deliveddate) }}月
										</div>
										<a
											:href="
												'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
													item.docid +
													'&leafid=' +
													item.leafid
											"
											target="_blank"
											class="detailsContent"
											:title="item.summary"
										>
											{{ item.summary }}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="policyBox2">
						<div class="policyTitle">
							<div
								class="asticle_l_title_item littleTitle flexRow"
								style="margin-bottom: 20px;"
							>
								<img
									src="../../assets/homeContent/title_icon.jpg"
									alt=""
								/>
								<a
									href="#/column?id=248&name=五周年专题&uid=A62302&showType=2"
									class="spanA"
									target="_blank"
									>政策回顾</a
								>
								<i></i>
								<a
									class="article_l_more"
									href="#/column?id=248&name=五周年专题&uid=A62302&showType=2"
									target="_blank"
									>更多<img
										src="../../assets/homeContent/more.png"
										alt=""
								/></a>
							</div>
							<div class="policyContent">
								<div class="policyDetailsBox">
									<div
										class="policyDetails"
										v-for="(item, index) in policy2"
										:key="index"
										v-if="policy2 && policy2.length"
									>
										<div class="detailsDate">
											{{ getMonth(item.deliveddate) }}月
										</div>
										<div class="detailsContent">
											<a
												:href="
													'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
														item.docid +
														'&leafid=' +
														item.leafid
												"
												target="_blank"
												class="detailsContentTitle"
											>
												{{ item.title }}
											</a>
											<a
												class="detailsContentC"
												:title="item.summary"
												:href="
													'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?docid=' +
														item.docid +
														'&leafid=' +
														item.leafid
												"
												target="_blank"
											>
												{{ item.summary }}
											</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="trade">
					<div
						class="asticle_l_title_item littleTitle flexRow"
						style="margin-bottom: 20px;"
					>
						<img
							src="../../assets/homeContent/title_icon.jpg"
							alt=""
						/>
						<a
							href="#/column?id=249&name=五周年专题&uid=A62303&showType=1-4"
							class="spanA"
							target="_blank"
							>行业聚焦</a
						>
						<i></i>
						<a
							class="article_l_more"
							href="#/column?id=249&name=五周年专题&uid=A62303&showType=1-4"
							target="_blank"
							>更多<img
								src="../../assets/homeContent/more.png"
								alt=""
						/></a>
					</div>
					<div>
						<treemap :currentYear="currentYear" :echartsData="''" />
					</div>
				</div>
				<div class="place">
					<div
						class="asticle_l_title_item littleTitle flexRow"
						style="margin-bottom: 20px;"
					>
						<img
							src="../../assets/homeContent/title_icon.jpg"
							alt=""
						/>
						<a
							href="#/column?id=247&name=五周年专题&uid=A62304&showType=1-1"
							target="_blank"
							class="spanA"
							>地方政策</a
						>
						<i></i>
						<a
							class="article_l_more"
							href="#/column?id=247&name=五周年专题&uid=A62304&showType=1-1"
							target="_blank"
							>更多<img
								src="../../assets/homeContent/more.png"
								alt=""
						/></a>
					</div>
					<div>
						<bar :currentYear="currentYear" :echartsData="''" />
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import $ from 'jquery';
import treemap from './components/treemap';
import bar from './components/bar';

import Header from '@/components/header';
import Footer from '@/components/footer';
export default {
	props: {},
	components: {
		Header,
		Footer,
		treemap,
		bar,
	},
	data() {
		return {
			years: [2020, 2021, 2022, 2023, 2024, 2025],
			currentYear: 2025,
			policy1: [],
			policy2: [],
		};
	},
	computed: {},
	created() {},
	mounted() {
		this.getPolicy1('A62301');
		this.getPolicy2('A62302');
	},
	methods: {
		onYearChange(y) {
			this.currentYear = y;
			// 在这里根据年份切换数据
			// e.g. this.fetchYearData(y)
			console.log('year changed:', y);
			this.getPolicy1('A62301');
			this.getPolicy2('A62302');
		},
		getPolicy1(_uid) {
			let param = {
				uid: _uid,
				startDate: this.currentYear + '-1-1',
				endDate: this.currentYear + '-12-31',
				isDefaltYear: '0',
				dateType: '2',
				pagesize: 2,
				curpage: 1,
			};
			api.getarticleList(param).then((res) => {
				this.policy1 = res.data.rows;
				console.log(res);
			});
		},
		getPolicy2(_uid) {
			let param = {
				uid: _uid,
				startDate: this.currentYear + '-1-1',
				endDate: this.currentYear + '-12-31',
				isDefaltYear: '0',
				dateType: '2',
				pagesize: 2,
				curpage: 1,
			};
			api.getarticleList(param).then((res) => {
				this.policy2 = res.data.rows;
				console.log(res);
			});
		},
		getMonth(dateStr) {
			return new Date(dateStr.replace(/-/g, '/')).getMonth() + 1;
		},
	},
};
</script>
<style scoped lang="less">
.viewBox {
	background: url('../../assets/fiveth/bg.png') no-repeat;
	.viewBoxContent {
		width: 1300px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		.titleImg {
			padding-top: 46px;
			margin-bottom: 31px;
		}
	}
}
.year-timeline {
	display: flex;
	justify-content: space-between;
	padding-bottom: 55px;
	.timeline-item {
		position: relative;
		background: #6cc06c;
		color: #fff;
		width: 224px;
		height: 45px;
		// font-weight: bold;
		border: 0;
		// padding: 10px 40px;
		// margin-right: 20px; /* 间隔 */
		clip-path: polygon(
			0 0,
			calc(100% - 30px) 0,
			100% 50%,
			calc(100% - 30px) 100%,
			0 100%,
			30px 50%
		);
		cursor: pointer;
		transition: background 0.3s;
		font-size: 25px;
	}

	.timeline-item.active {
		background: #00923f; /* 高亮 */
	}

	.timeline-item:hover {
		background: #57a857;
	}
}

.asticle_l_title_item {
	font-family: Source Han Sans CN;
	font-weight: 600;
	font-size: 18px;
	color: #1a1a1a;
	align-items: center;
	img {
		width: 3px;
		height: 18px;
		vertical-align: middle;
	}
	.spanA {
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 0 11px 0 5px;
	}
	span {
		display: inline-block;
		overflow: hidden;
		white-space: nowrap;
		min-width: min-content;
		margin: 0 11px 0 5px;
	}
	i {
		font-style: normal;
		width: 100%;
		height: 10px;

		display: inline-block;
		background: url('../../assets/homeContent/title_sp.jpg') repeat-x center;
	}
}
.littleTitle {
	.spanA {
		font-family: Source Han Sans CN;
		font-weight: 600;
		font-size: 16px !important;
		color: #1a1a1a !important;
	}
}
.article_l_more {
	display: inline-block;
	cursor: pointer;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 300;
	color: #1a1a1a;
	display: inline-block;
	overflow: hidden;
	white-space: nowrap;
	min-width: min-content;
	margin: -1px 0 0 8px;
	img {
		margin-left: 6px;
		margin-right: 3px;
		width: 9px;
		height: 9px;
	}
}
.flexRow {
	display: flex !important;
	flex-direction: row;
	justify-content: space-between;
}
.flexClounm {
	display: flex !important;
	flex-direction: column;
	justify-content: space-between;
}

.policy {
	display: flex;
	justify-content: space-between;
	padding-bottom: 56px;
	.policyDetailsBox {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 5px 0;
		width: 100%;
		.policyDetails {
			display: flex;
			flex-direction: row;
			align-items: center;

			.detailsDate {
				min-width: 49px;
				min-height: 49px;
				display: block;
				background: #cfefc6;
				border-radius: 50%;
				font-weight: bold;
				font-size: 18px;
				color: #4e982d;
				line-height: 48px;
				text-align: center;
				margin-left: 28px;
			}
			.detailsContent {
				height: 68px;
				padding-left: 10px;
				line-height: 24px;
				font-size: 15px;
				color: #333333;
				cursor: pointer;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 3;
				overflow: hidden;
			}
		}
	}
	.policyBox1 {
		width: 48%;
		.policyContent {
			display: flex;
			height: 187px;
		}
	}
	.policyBox2 {
		width: 48%;
		.policyContent {
			display: flex;
			height: 187px;
			.policyDetails {
				.detailsDate {
					margin-left: 1px;
				}
				.detailsContent {
					.detailsContentTitle {
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						font-weight: 600;
						font-size: 15px;
						color: #333333;
						line-height: 24px;
					}
					.detailsContentC {
						height: 48px;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
						overflow: hidden;
						font-weight: 400;
						font-size: 14px;
						color: #666666;
						line-height: 22px;
					}
				}
			}
		}
	}
}
.trade {
	padding-bottom: 43px;
}
</style>



// WEBPACK FOOTER //
// src/view/fiveth/index.vue